import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import ThemedChartCard from "../ThemedChartCard";

const CompletedTripsChart = ({ monthlyData }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  
  const [activeTheme, setActiveTheme] = useState(() => 
    document.documentElement.classList.contains("dark") ? "dark" : "light"
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const isDark = document.documentElement.classList.contains("dark");
      setActiveTheme(isDark ? "dark" : "light");
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    });

    return () => observer.disconnect();
  }, []);

  const parsedData = monthlyData || [];
  const categories = parsedData.map(item => (item.month_name || "").substring(0, 3));
  const values = parsedData.map(item => item.count || 0);

  useEffect(() => {
    if (chartRef.current) {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.dispose();
      }
      chartInstanceRef.current = echarts.init(chartRef.current);

      const isDark = activeTheme === "dark";
      const labelColor = isDark ? "#94a3b8" : "#64748b";
      const lineColor = isDark ? "#1c1d1f" : "#e3e6f0";
      const barColor = "#10b981";

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: categories,
            axisTick: {
              show: false
            },
            axisLabel: {
              color: labelColor
            },
            axisLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: labelColor
            },
            splitLine: {
              lineStyle: {
                color: lineColor
              }
            }
          }
        ],
        series: [
          {
            name: "Completed Trips",
            type: "bar",
            barWidth: "60%",
            data: values,
            itemStyle: {
              color: barColor,
              borderRadius: [4, 4, 0, 0]
            }
          }
        ]
      };

      chartInstanceRef.current.setOption(option);

      const handleResize = () => {
        if (chartInstanceRef.current) {
          chartInstanceRef.current.resize({
            animation: {
              duration: 300
            }
          });
        }
      };

      const resizeObserver = new ResizeObserver(handleResize);
      if (chartRef.current) {
        resizeObserver.observe(chartRef.current);
      }

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
        resizeObserver.disconnect();
        chartInstanceRef.current?.dispose();
      };
    }
  }, [monthlyData, activeTheme]);

  return (
    <ThemedChartCard title="Completed Trips by Month" className="h-[270px]">
      <div className="w-full h-[200px] relative">
        <div ref={chartRef} className="w-full h-full absolute inset-0" style={{ minHeight: "200px" }} />
      </div>
    </ThemedChartCard>
  );
};

export default CompletedTripsChart;
